import React from 'react'
import { FormattedMessage } from 'react-intl'
import { DropdownItem, DropdownMenu } from 'reactstrap'
import * as Icon from 'react-feather'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { showConfirmAlert } from '../../../redux/actions/ui/Index'
import { logoutAction } from '../../../redux/actions/auth'

const UserDropdown = () => {
  
  const history = useHistory()
  const dispatch = useDispatch()

  const handleNavigation = (e, path) => {
    e.preventDefault()
    history.push(path)
  }

  const onClickLogout = () => {
    dispatch(
      showConfirmAlert({
        title: <FormattedMessage id='navbar.logout' />,
        isShow: true,
        content: <FormattedMessage id='navbar.logout.confirmMessage' />,
        onConfirm: () => {
          dispatch(logoutAction())
        }
      })
    )
  }

  return (
    <DropdownMenu right>
      <DropdownItem
        tag='a'
        href='#'
        onClick={(e) => handleNavigation(e, '/account-info')}
      >
        <Icon.User size={14} className='mr-50' />
        <span className='align-middle'>
          <FormattedMessage id='setting.accountInformation' />
        </span>
      </DropdownItem>
      <DropdownItem
        tag='a'
        href='#'
        onClick={(e) => handleNavigation(e, '/change-password')}
      >
        <Icon.Lock size={14} className='mr-50' />
        <span className='align-middle'>
          <FormattedMessage id='setting.changePassword' />
        </span>
      </DropdownItem>
      <DropdownItem divider />
      <DropdownItem
        tag='a'
        href='#'
        onClick={(e) => handleNavigation(e, '/terms-and-condition')}
      >
        <Icon.FileText size={14} className='mr-50' />
        <span className='align-middle'>
          <FormattedMessage id='setting.termAndCondition' />
        </span>
      </DropdownItem>
      <DropdownItem
        tag='a'
        href='#'
        onClick={(e) => handleNavigation(e, '/privacy-policy')}
      >
        <Icon.Shield size={14} className='mr-50' />
        <span className='align-middle'>
          <FormattedMessage id='setting.privacyPolicy' />
        </span>
      </DropdownItem>
      <DropdownItem
        tag='a'
        href='#'
        onClick={(e) => handleNavigation(e, '/language')}
      >
        <Icon.Globe size={14} className='mr-50' />
        <span className='align-middle'>
          <FormattedMessage id='setting.language' />
        </span>
      </DropdownItem>
      <DropdownItem
        tag='a'
        href='#'
        onClick={(e) => handleNavigation(e, '/contact')}
      >
        <Icon.MessageSquare size={14} className='mr-50' />
        <span className='align-middle'>
          <FormattedMessage id='setting.contact' />
        </span>
      </DropdownItem>
      <DropdownItem divider />
      <DropdownItem tag='a' onClick={onClickLogout}>
        <Icon.Power size={14} className='mr-50' />
        <span className='align-middle'>
          <FormattedMessage id='navbar.logout' />
        </span>
      </DropdownItem>
    </DropdownMenu>
  )
}

export default UserDropdown
